// Routes with subroutes possible see: https://reactrouter.com/web/example/route-config
// Note: subroute components would display on page WITH parent route component

import { matchPath } from 'react-router-dom';
import deepmerge from 'deepmerge';
import {
  COMPONENT_CURATED,
  // COMPONENT_INDEX,
  COMPONENT_NOTFOUND,
  COMPONENT_DASHBOARD,
  COMPONENT_TUTORIAL,
  COMPONENT_CURATED_TUTORIAL,
  COMPONENT_UNIT_WRAPPER,
  COMPONENT_MODULE_UNIT_WRAPPER,
  PERF_ENV, MAINTENANCE_MODE, COMPONENT_CATALOG, ROUTER_BASENAME,
  EDC_SLUGS_INDEX, EDC_SLUGS_CATALOG,
  COMPONENT_LIVE_CLASS_ENROLLMENT, COMPONENT_LIST, COMPONENT_COLLECTION,
  COMPONENT_COACHING_REQUEST,
  APP_PROBLEM_EDITOR,
  COMPONENT_INDEX,
} from './constants';
import { setChildProperty } from './object';
import {
  getDataState, getSearchResult, getStaticContent, getAvailableProducts, getEnrollmentData,
} from '../store/universalDataFetchers';
import { getEnvironmentConstant } from './utilities';
import logger from './logger';
import XHRError from './xhrError';

export const validateStillOffered = (data) => {
  if (!data.stillOffered) {
    throw new XHRError(404, 'content has been retired');
  }
};

export const defaultRoutes = [
  {
    path: '/',
    componentKey: COMPONENT_INDEX,
    editorialContentSlugs: EDC_SLUGS_INDEX,
    editorialDataObject: 'indexData.editorial',
    pageLevelDataCall: getAvailableProducts,
    pageLevelDataCallProps: ['env', 'appVersion'],
    storeDataObject: 'indexData.data',
    exact: true,
  },
  {
    path: '/index.html',
    componentKey: COMPONENT_INDEX,
    editorialContentSlugs: EDC_SLUGS_INDEX,
    editorialDataObject: 'indexData.editorial',
    pageLevelDataCall: getAvailableProducts,
    pageLevelDataCallProps: ['env', 'appVersion'],
    storeDataObject: 'indexData.data',
    exact: true,
  },
  {
    path: '/catalog',
    componentKey: COMPONENT_CATALOG,
    editorialContentSlugs: EDC_SLUGS_CATALOG,
    editorialDataObject: 'catalogData.editorial',
    pageLevelDataCall: getSearchResult,
    pageLevelDataCallProps: ['catalogResult', 'presetFilterString', 'env', 'appVersion'],
    storeDataObject: 'catalogData.result|catalogData.filterHistory',
    exact: false,
  },
  {
    path: '/live/enroll/:classId/:hash',
    componentKey: COMPONENT_LIVE_CLASS_ENROLLMENT,
    exact: false,
    pageLevelDataCall: getEnrollmentData,
    pageLevelDataCallProps: ['isPreview', 'env', 'appVersion', 'params'],
    storeDataObject: 'enrollmentData.data|enrollmentData.editorial|enrollmentData.isLoaderVisible',
  },
  {
    path: '/coaching/:action',
    componentKey: COMPONENT_COACHING_REQUEST,
    exact: true,
  },
  {
    path: '/ondemand/curated/:curated',
    componentKey: COMPONENT_CURATED,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'curatedData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/course/:course',
    componentKey: COMPONENT_CURATED,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'curatedData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/tutorial/:tutorial',
    componentKey: COMPONENT_TUTORIAL,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'tutorialData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/module/:module',
    componentKey: COMPONENT_TUTORIAL,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'tutorialData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/curated/:curated/:tutorialId',
    componentKey: COMPONENT_CURATED_TUTORIAL,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'curatedData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/course/:course/module/:moduleId',
    componentKey: COMPONENT_CURATED_TUTORIAL,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'curatedData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/course/:course/unit/:unitId',
    componentKey: COMPONENT_UNIT_WRAPPER,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'curatedData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/ondemand/module/:module/unit/:unitId',
    componentKey: COMPONENT_MODULE_UNIT_WRAPPER,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'tutorialData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/list/:listId',
    componentKey: COMPONENT_LIST,
    exact: true,
  },
  {
    path: '/dashboard',
    componentKey: COMPONENT_DASHBOARD,
    exact: true,
  },
  {
    path: '/ondemand/collection/:collectionSlug',
    componentKey: COMPONENT_COLLECTION,
    exact: true,
    pageLevelDataCall: getDataState,
    pageLevelDataCallProps: ['params', 'env', 'useMocks', 'isPreview'],
    storeDataObject: 'collectionData.data',
    mockDataPath: '../../mocks/fullStateMock.json',
    validation: validateStillOffered,
  },
  {
    path: '/app/problemEditor',
    componentKey: APP_PROBLEM_EDITOR,
    exact: true,
  },
  {
    path: '*',
    componentKey: COMPONENT_NOTFOUND,
    status: 404,
  },

];

export const maintenanceRoutes = [
  {
    path: '*',
    componentKey: MAINTENANCE_MODE,
    status: 200,
  },
];

// Called from SSR /server/lib/render.tsx to fetch associated server-side data for a route.
export const getDataForPath = async (props) => {
  const {
    path, env, isMaintenanceMode, isSSR,
  } = props;
  const routes = isMaintenanceMode ? maintenanceRoutes : defaultRoutes;
  logger.info('getDataForPath: ', path, getEnvironmentConstant({ key: ROUTER_BASENAME, env }));

  const matchedRoute = routes
    .map((route) => ({ route, match: matchPath(path.replace(getEnvironmentConstant({ key: ROUTER_BASENAME, env }), ''), route) }))
    .filter((combined) => combined.match !== null);
  let returnedData = {};
  let editorialData = {};
  logger.info('getDataForPath matchedRoute:', JSON.stringify(matchedRoute));

  if (env !== PERF_ENV) {
    const dataCalls = [];
    if (matchedRoute[0] && matchedRoute[0].route.pageLevelDataCall) {
      logger.info('Pushing Page Level data');
      // eslint-disable-next-line no-param-reassign
      props.params = matchedRoute[0].match.params;
      const callProps = [];
      if (matchedRoute[0].route.pageLevelDataCallProps) {
        matchedRoute[0].route.pageLevelDataCallProps.forEach((prop) => {
          callProps[prop] = props[prop];
        });
      }
      dataCalls.push(matchedRoute[0].route.pageLevelDataCall(callProps).then((res) => {
        if (Object.prototype.hasOwnProperty.call(matchedRoute[0].route, 'validation')) {
          matchedRoute[0].route.validation(res);
        }

        return res;
      }));
    } else {
      logger.info('Pushing Page Level Empty');
      // Must push a null to keep related positions correct in result splitting
      dataCalls.push(Promise.resolve({}));
    }

    if (matchedRoute[0] && matchedRoute[0].route.editorialContentSlugs) {
      logger.info('Pushing EDC data');
      // eslint-disable-next-line no-param-reassign
      dataCalls.push(getStaticContent({
        slugs: matchedRoute[0].route.editorialContentSlugs, env: props.env, isPreview: props.isPreview, isSSR,
      }));
    } else {
      logger.info('Pushing EDC Empty');
      // Must push a null to keep related positions correct in result splitting
      dataCalls.push(Promise.resolve({}));
    }

    await Promise.all(dataCalls).then(([pld, ed]) => {
      returnedData = pld;
      editorialData = ed;
    });
  } else if (matchedRoute[0] && matchedRoute[0].route.mockDataPath) {
    returnedData = await import(matchedRoute[0].route.mockDataPath);
  }

  if (isSSR && returnedData && matchedRoute[0].route.storeDataObject) {
    if (!returnedData.error) {
      // Handle wrapping data with store slice structure for SSR
      const splitStore = matchedRoute[0].route.storeDataObject.split('|');

      if (splitStore.length > 1 && Array.isArray(returnedData)) {
        const newData = {};
        splitStore.forEach((storeKey, idx) => {
          setChildProperty(returnedData[idx], storeKey, newData);
        });
        returnedData = newData;
      } else {
        returnedData = setChildProperty(returnedData, matchedRoute[0].route.storeDataObject, {});
      }
      returnedData[matchedRoute[0].route.storeDataObject.split('.')[0]].isLoaderVisible = false;
    }
  }

  if (isSSR && editorialData && matchedRoute[0].route.editorialDataObject) {
    if (!editorialData.error) {
      // Handle wrapping data with store slice structure for SSR
      editorialData = setChildProperty(editorialData, matchedRoute[0].route.editorialDataObject, {});
    }
  }

  if (matchedRoute[0] && matchedRoute[0]?.route?.status) {
    if (returnedData) {
      returnedData.status = matchedRoute[0].route.status;
    } else {
      returnedData = { status: matchedRoute[0].route.status };
    }
  }

  return deepmerge(returnedData, editorialData);
};
